import { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

/**
* Renders a themed skeleton placeholder for community statistics without actual data.
* @example
* CommunityStatsSkeleton()
* <div className="rounded-lg p-6">...</div>
* @param {{}} _ - Placeholder argument; this component accepts no props.
* @returns {JSX.Element} A skeleton layout composed of animated placeholders.
*/
const CommunityStatsSkeleton = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div 
      className="rounded-lg p-6"
      style={{ 
        backgroundColor: theme.background.card,
        boxShadow: theme.shadow.md
      }}
    >
      {/* Header */}
      <div 
        className="h-6 rounded w-40 mb-4 animate-pulse"
        style={{ backgroundColor: theme.background.secondary }}
      />

      {/* Stats grid */}
      <div className="grid grid-cols-2 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="space-y-2">
            <div className="flex items-center gap-2">
              <div 
                className="size-5 rounded animate-pulse"
                style={{ backgroundColor: theme.background.secondary }}
              />
              <div 
                className="h-4 rounded w-16 animate-pulse"
                style={{ backgroundColor: theme.background.secondary }}
              />
            </div>
            <div 
              className="h-6 rounded w-12 animate-pulse"
              style={{ backgroundColor: theme.background.secondary }}
            />
            <div 
              className="h-3 rounded w-20 animate-pulse"
              style={{ backgroundColor: theme.background.secondary }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunityStatsSkeleton;
